export enum QUERY_KEYS {
	GET_ORGANIZATION = 'get-organization',
	GET_ORGANIZATIONS = 'get-organizations',
	GET_SELECTED_CUSTOM_REPORT_RESULTS = 'get-selected-custom-report-results',
	GET_CUSTOM_REPORT_STEPS_BY_RESULT = 'get-custom-report-steps-by-result',
	GET_CUSTOM_REPORT_STEP_KEYS_BY_RESULT = 'get-custom-report-step-keys-by-result',
	GET_CUSTOM_REPORTS = 'get-custom-reports',
	GET_MOSAIC = 'get-mosaic',
	GET_STRAIN_INDEX_RSI = 'get-strain-index-rsi',
	GET_CHECKLIST_REPORTS = 'get-checklist-reports',
	GET_DELAYED_ACTION_PLANS = 'get-delayed-action-plans',
	GET_PERCENTILE_BY_GENDER = 'percentile-by-gender',
	GET_STATUS_ACTION_PLANS = 'get-status-action-plans',
	GET_CUSTOM_REPORT_RISKS_COUNT = 'get-custom-report-risks-count',
	GET_BERA_COMPARISON = 'get-bera-comparison',
	GET_SERA_COMPARISON = 'get-sera-comparison',
	GET_BERA_SIX_TOO = 'get-bera-six-too',
	GET_SERA_MAIN_RISK = 'get-sera-main-risk',
	GET_SERA_SUM_RPN = 'get-sera-sum-rpn',
	GET_BERA_SUM_RPN = 'get-bera-sum-rpn',
	GET_REBA_EXPOSURE_SCORE = 'get-reba-exposure-score',
	GET_REBA_EXPOSURE_BODY = 'get-reba-exposure-body',
	GET_REBA_WORST_GRADE = 'get-reba-worst-grade',
	GET_REBA_SCORE_PARTS = 'get-reba-score-parts',
	GET_REBA_SCORES = 'get-reba-scores',
	GET_REBA_RISK_RANGE = 'get-reba-risk-range',
	GET_REBA_SCORE_PER_SECOND = 'get-reba-score-per-second',
	GET_NIOSH_RISKS_COUNT = 'get-niosh-risks-count',
	GET_NIOSH_REPORT = 'get-niosh-report',
	GET_KIM_PP_REPORT = 'get-kim-pp-report',
	GET_KIM_MHO_REPORT = 'get-kim-mho-report',
	GET_KIM_MHO_RISKS_COUNT = 'get-kim-mho-risks-count',
	GET_KIM_PP_RISKS_COUNT = 'get-kim-pp-risks-count',
	GET_BERA_GNS = 'get-bera-gns',
	GET_EWA_CUSTOM_REPORT_RESULTS = 'get-ewa-custom-report-results',
	GET_CUSTOM_REPORTS_CONSOLIDATED = 'get-custom-reports-consolidated',
	GET_CUSTOM_REPORT_LAST_CONSOLIDATED_ACTION_LOG = 'get-custom-report-last-consolidated-action-log',
	GET_ERGONOMIC_WORK_ANALYSIS_LIST = 'get-ergonomic-work-analysis-list',
	GET_ACTION_PLAN_LIST = 'get-action-plan-list',
	GET_METHOD_LIST_OPTIONS = 'get-method-list-options',
	GET_METHOD = 'get-method',
	GET_COMPANIES = 'get-companies-options',
	GET_LINES = 'get-lines-options',
	GET_SECTORS = 'get-sectors-options',
	GET_WORKSTATIONS_OPTIONS = 'get-workstations-options',
	GET_ACTIVITIES_OPTIONS = 'get-activities-options',
	GET_RESPONSIBLES_OPTIONS = 'get-responsibles-options',
	GET_CUSTOM_REPORT_OPTIONS = 'get-custom-report-options',
	GET_ATTACHMENTS = 'get-attachments',
	GET_ERGONOMIC_WORK_ANALYSIS = 'get-ergonomic-work-analysis',
	GET_EWA_SELECTED_STEP_KEY_RESULTS = 'get-ewa-selected-step-key-results',
	GET_ERGONOMIC_WORK_ANALYSIS_IMAGES = 'get-ergonomic-work-analysis-images',
	GET_RELATED_REPORTS = 'get-related-reports',
	GET_ACTION_PLAN_CARD_LIST = 'get-action-plan-card-list',
	GET_ACTION_PLAN_ORIGINS = 'get-action-plan-origins',
	GET_ACTION_PLAN_USER_PREFERENCE_COLUMNS = 'get-action-plan-user-preference-columns',
	GET_ACTION_PLAN_HISTORY = 'get-action-plan-history',
	GET_ACTION_PLAN_COMMENTS = 'get-action-plan-comments',
	GET_ACTION_PLAN_NOTIFICATIONS = 'get-action-plan-notifications',
	CREATE_ACTION_PLAN_COMMENTS = 'create-action-plan-comments',
	UPDATE_ACTION_PLAN_COMMENTS = 'update-action-plan-comments',
	DELETE_ACTION_PLAN_COMMENTS = 'delete-action-plan-comments',
	GET_ACTION_PLAN = 'get-action-plan',
	GET_ACTION_PLAN_TASKS = 'get-action-plan-tasks',
	GET_ACTION_PLANS_COUNT = 'get-action-plans-count',
	GET_EVIDENCES = 'get-evidences',
	GET_ATTACHMENT_DOWNLOAD_URL = 'get-attachment-download-url',
	GET_TASK_ATTACHMENT_DOWNLOAD_URL = 'get-task-attachment-download-url',
	GET_ACTION_PLAN_FROM_REPORT = 'get-action-plan-from-report',
	GET_ACTION_PLANS_BY_REPORT = 'get-action-plans-by-report',
	GET_NOTIFICATION_STATUS = 'get-notification-status',
	GET_ERGONOMIC_TOOLS = 'get-ergonomic-tools',
	CREATE_DATA_EXTRACTION = 'create-data-extraction',
	UPDATE_DATA_EXTRACTION = 'update-data-extraction',
	GET_WORKSTATIONS = 'get-workstations',
	GET_DATA_EXTRACTION = 'get-data-extraction',
	DATA_EXTRACTION_ALL_IDS = 'data-extraction-all-ids',
	DATA_EXTRACTION_ACTION_PLAN_COLUMNS = 'data-extraction-action-plan-columns',
	UPDATE_NOTIFICATION_STATUS = 'update-notification-status',
	ERGONOMIC_TOOLS = 'ergonomic-tools',
	GET_DATA_EXTRACTION_LIST = 'get-data-extraction-list',
	GET_ERGONOMIC_TOOL_LIST = 'get-ergonomic-tool-list',
	GET_TOTAL_CREATED_CUSTOM_REPORTS = 'get-total-created-custom-reports',
	GET_ACTION_PLANS_COUNT_BY_REPORT = 'get-action-plans-count-by-report',
	GET_ACTION_PLANS_COUNT_BY_REPORTS = 'get-action-plans-count-by-reports',
	GET_ERGONOMIC_TOOLS_BY_REPORT = 'get-ergonomic-tools-by-report',
	GET_DATA_EXTRACTION_CSV_TO_DOWNLOAD = 'get-data-extraction-csv-to-download',
	GET_DATA_EXTRACTION_MODEL_LIST = 'get-data-extraction-model-list',
	GET_DATA_EXTRACTION_MODEL = 'get-data-extraction-model',
	GET_CUSTOM_REPORT_BY_TYPE_LIST = 'get-custom-report-by-type-list',
	GET_DATA_EXTRACTION_SELECTED_REPORTS_COUNT = 'get-data-extraction-selected-reports-count',
	GET_EXTRACTION_FILES_LIST = 'get-extraction-files-list',
	GET_DATA_EXTRACTION_INFINITE_FILES = 'get-data-extraction-infinite-files',
	GET_FILE_REPORTS_AND_TOOLS = 'get-file-reports-and-tools',
	GET_ACTION_PLANS_EWA = 'get-action-plans-ewa',
	GET_LIST_RESOLUTION_886 = 'get-list-resolution-886',
	DELETE_RESOLUTION_886 = 'delete-resolution-886',
	GET_FILES_LIST = 'get-file-list',
	LIST_WORKERS = 'list-workers',
	GET_LIST_WORKER = 'get-list-worker',
	GET_WORKER = 'get-worker',
	CREATE_WORKER = 'create-worker',
	UPDATE_WORKER = 'update-worker',
	DELETE_WORKER = 'delete-worker',
	GET_LIST_EMPLOYER = 'get-list-employer',
	GET_EMPLOYER = 'get-employer',
	CREATE_EMPLOYER = 'create-employer',
	UPDATE_EMPLOYER = 'update-employer',
	DELETE_EMPLOYER = 'delete-employer',
	GET_LIST_OCCUPATIONAL_DOCTOR = 'get-list-occupational-doctor',
	GET_OCCUPATIONAL_DOCTOR = 'get-occupational-doctor',
	CREATE_OCCUPATIONAL_DOCTOR = 'create-occupational-doctor',
	UPDATE_OCCUPATIONAL_DOCTOR = 'update-occupational-doctor',
	DELETE_OCCUPATIONAL_DOCTOR = 'delete-occupational-doctor',
	GET_LIST_SAFETY_AND_HYGIENE_RESPONSIBLE = 'get-list-safety-and-hygiene-responsible',
	GET_SAFETY_AND_HYGIENE_RESPONSIBLE = 'get-safety-and-hygiene-responsible',
	CREATE_SAFETY_AND_HYGIENE_RESPONSIBLE = 'create-safety-and-hygiene-responsible',
	UPDATE_SAFETY_AND_HYGIENE_RESPONSIBLE = 'update-safety-and-hygiene-responsible',
	DELETE_SAFETY_AND_HYGIENE_RESPONSIBLE = 'delete-safety-and-hygiene-responsible',
	GET_LIST_EVALUATOR = 'get-list-evaluator',
	GET_EVALUATOR = 'get-evaluator',
	GET_LIST_ORGANIZATION = 'get-list-organization',
	GET_RESOLUTION_886 = 'get-resolution-886',
	CREATE_EVALUATOR = 'create-evaluator',
	CREATE_RESOLUTION_886_ASSESSMENT = 'create-resolution-886-assessment',
	UPDATE_RESOLUTION_886_ASSESSMENT = 'update-resolution-886-assessment',
	GET_RESOLUTION_886_ASSESSMENT = 'get-resolution-886-assessment',
	GET_RESOLUTION_886_ASSESSMENT_LIST = 'get-resolution-886-assessment-list',
	GET_RESOLUTION_886_CATEGORY_RESULT = 'get-resolution-886-assesssment-category-result',
	CREATE_UPDATE_RESOLUTION_886_CATEGORY_QUESTION = 'create-update-resolution-886-category-question',
	GET_RESOLUTION_886_CATEGORY_QUESTION = 'get-resolution-886-category-question',
	CREATE_RESOLUTION_886_CATEGORY_RESULT = 'create-resolution-886-category-result',
	UPDATE_RESOLUTION_886_CATEGORY_RESULT = 'update-resolution-886-category-result',
	GET_RESOLUTION_886_CATEGORY = 'get-resolution-886-category-result',
	GET_RESOLUTION_886_ASSESSMENT_ATTACHMENT_LIST = 'get-resolution-886-assessment-attachment-list',
	GET_RESOLUTION_886_REPORT_REVIEW = 'get-resolution-886-report-review',
	GET_RESOLUTION_886_CATEGORY_RESULT_LIST = 'get-resolution-886-category-result-list',
	CREATE_UPDATE_PREVENTIVE_MEASURE = 'create-update-preventive-measure',
	GET_RESOLUTION_886_REPORT_PDF = 'get-resolution-886-report-pdf',
	GET_RESOLUTION_886_REVIEW_RESULTS = 'get-resolution-886-review-results',
	GET_PREVENTIVE_MEASURE = 'get-preventive-measure',
	GENERATE_RESOLUTION_886_PDF = 'generate-resolution-886-pdf',
	GET_LIST_RESOLUTION_886_FILES = 'get-list-resolution-886-files',
	GET_DASHBOARD_WORST_RISK_LEVEL = 'get-dashboard-worst-risk-level',
	GET_DASHBOARD_RISK_LEVEL = 'get-dashboard-risk-level',
	GET_LIST_RESOLUTION_886_GENERAL_RESULT = 'get-list-resolution-886-general-result',
	GENERATE_RESOLUTION_886_GENERAL_PDF = 'generate-resolution-886-general-pdf',
	GET_ROSA = 'get-rosa',
	GET_ROSA_LIST = 'get-rosa-list',
	GET_ROSA_ELEMENTS = 'get-rosa-elements',
	GET_ROSA_IMAGES = 'get-rosa-images',
	GET_ROSA_SCORES = 'get-rosa-scores',
	GET_ROSA_REQUIRED_EQUIPMENTS = 'get-rosa-required-equipments',
	GET_ROSA_ACTION_PLANS = 'get-rosa-action-plans',
	GET_ROSA_RESULT = 'get-rosa-result',
	GET_ACTION_PLANS_BY_ORIGIN = 'get-action-plans-by-origin',
	GET_ATTACHMENT_LIST = 'get-attachment-list',
	GET_CUSTOM_REPORT_RESULT_ACTION_PLANS = 'get-custom-report-result-action-plans',
	GET_LIBERTY_MUTUAL_RESULT = 'get-liberty-mutual-result',
	GET_STRAIN_INDEX_REPORT = 'get-strain-index-report',
	GET_SIGNATURE_RESPONSIBLE = 'get-signature-responsible',
	LIST_SIGNATURE_RESPONSIBLES = 'list-signature-responsibles',
	GET_CUSTOM_REPORT_ERGONOMIC_TOOLS = 'get-custom-report-ergonomic-tools',
	GET_KIM_LHC = 'get-kim-lhc',
	GET_KIM_LHC_RESULT = 'get-kim-lhc-result',
	GET_RISK_EVALUATION = 'get-risk-evaluation',
	GET_VIDEO_INFO = 'get-video-info',
	GET_BERA_REPORT_V2 = 'get-bera-report-v2',
	GET_BERA_STEP_KEY_RESULTS = 'get-bera-step-key-results',
	GET_BERA_STEP_KEY_OPTIONS = 'get-bera-step-key-options',
	GET_BERA_SUMMARY_RESULT = 'bera_job_results',
	GET_BERA_SUMMARY_RESULT_V2 = 'get-bera-summary-result-v2',
	GET_BERA_JOB_SUMMARY_LIST = 'get-bera-job-summary-list',
	GET_BERA_VERSION_LIST = 'get-bera-version-list',
	GET_BERA_JOB_SUMMARY = 'bera_job_summary',
	GET_BERA_FILES = 'bera_files',
	GET_BERA_REPORTS_V2 = 'bera_reports_v2',
	GET_DOWNLOAD_VIDEO_URL = 'download_video_url',
}
